import React from 'react'
import Header from '../Components/Header'
import WhoWeAre from '../Components/WhoWeAre'
import WhatWeDo from '../Components/WhatWeDo'
import WhyUs from '../Components/WhyUs'
import Footer from '../Components/Footer'

const AboutUs = () => {
  return (
    <>
    <Header />
    <WhoWeAre />
    <WhatWeDo />
    <WhyUs />
    <Footer />
    </>
  )
}

export default AboutUs